import React from 'react';

/* The B/N icon set. Drawn for B/N — one 24px grid, one 1.75 stroke, round ends
   and joins, no fills — so every icon in the app reads as the same family as
   the "introduction" mark. Add new icons here in the same style, never from a
   library, or the set stops being one set.

   Each entry is a list of SVG elements: [tag, attributes]. */
const I = {
  home: [['path', { d: 'M4 10.5 12 4l8 6.5V19a1 1 0 0 1-1 1h-4.5v-5.5h-5V20H5a1 1 0 0 1-1-1z' }]],
  news: [
    ['path', { d: 'M5 5h11v13a2 2 0 0 0 2 2H7a2 2 0 0 1-2-2z' }],
    ['path', { d: 'M16 9h3v9a2 2 0 0 1-2 2' }],
    ['path', { d: 'M8 9h5M8 12.5h5M8 16h3' }],
  ],
  people: [
    ['circle', { cx: 9, cy: 8.5, r: 3 }],
    ['path', { d: 'M3.5 19.5c0-3.1 2.5-5.3 5.5-5.3s5.5 2.2 5.5 5.3' }],
    ['circle', { cx: 16.5, cy: 9.5, r: 2.3 }],
    ['path', { d: 'M15.8 14.3c2.7-.3 4.7 1.6 4.7 4.2' }],
  ],
  groups: [
    ['rect', { x: 3.5, y: 4.5, width: 17, height: 12, rx: 2.5 }],
    ['path', { d: 'M8 20h8M12 16.5V20M7.5 9.5h9M7.5 12.5h5.5' }],
  ],
  bookmark: [['path', { d: 'M7 4.5h10a1 1 0 0 1 1 1v14l-6-4-6 4v-14a1 1 0 0 1 1-1z' }]],
  copilot: [
    ['path', { d: 'M11 3.5l1.9 5.2 5.1 1.8-5.1 1.9L11 17.6l-1.9-5.2L4 10.5l5.1-1.8z' }],
    ['path', { d: 'M18.5 15.2l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z' }],
  ],
  profile: [
    ['circle', { cx: 12, cy: 8, r: 3.5 }],
    ['path', { d: 'M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6' }],
  ],
  plus: [['path', { d: 'M12 5v14M5 12h14' }]],
  history: [
    ['path', { d: 'M4.5 12a7.5 7.5 0 1 0 2.2-5.3' }],
    ['path', { d: 'M4.5 4.5v3.7h3.7' }],
    ['path', { d: 'M12 8v4.3l2.8 1.7' }],
  ],
  compose: [
    ['path', { d: 'M19.5 12.5V18a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 18V6A1.5 1.5 0 0 1 6 4.5h5.5' }],
    ['path', { d: 'M16.5 4.2l3.3 3.3-7.8 7.8H8.7V12z' }],
  ],
  close: [['path', { d: 'M6.5 6.5l11 11M17.5 6.5l-11 11' }]],
  back: [['path', { d: 'M14.5 6 8.5 12l6 6' }]],
  send: [
    ['path', { d: 'M4.5 11.8 19.5 4.5 15 19.5l-3.2-5.8z' }],
    ['path', { d: 'M11.8 13.7 19.5 4.5' }],
  ],
  attach: [['path', { d: 'M16 7.5 9 14.5a2 2 0 0 0 2.9 2.9l7-7a4 4 0 0 0-5.7-5.7l-7 7a6 6 0 0 0 8.5 8.5l5.3-5.3' }]],
  bolt: [['path', { d: 'M13 3.5 5.5 13.5h5.5l-1 7 7.5-10h-5.5z' }]],
  think: [
    ['path', { d: 'M9.5 18h5M10.5 21h3' }],
    ['path', { d: 'M12 3.5a5.8 5.8 0 0 0-3.4 10.5c.6.5.9 1.1.9 1.8v.2h5v-.2c0-.7.3-1.3.9-1.8A5.8 5.8 0 0 0 12 3.5z' }],
  ],
  heart: [['path', { d: 'M12 19.5s-7-4.3-7-9.7A3.9 3.9 0 0 1 12 7.4a3.9 3.9 0 0 1 7 2.4c0 5.4-7 9.7-7 9.7z' }]],
  comment: [['path', { d: 'M5.5 5h13a1.5 1.5 0 0 1 1.5 1.5v8.5a1.5 1.5 0 0 1-1.5 1.5H11l-4.5 3.5v-3.5h-1A1.5 1.5 0 0 1 4 15V6.5A1.5 1.5 0 0 1 5.5 5z' }]],
  hide: [
    ['circle', { cx: 12, cy: 12, r: 8 }],
    ['path', { d: 'M8.5 12h7' }],
  ],
  external: [
    ['path', { d: 'M13.5 5.5H18.5V10.5M18.5 5.5 11 13' }],
    ['path', { d: 'M17 14v3.5A1.5 1.5 0 0 1 15.5 19h-9A1.5 1.5 0 0 1 5 17.5v-9A1.5 1.5 0 0 1 6.5 7H10' }],
  ],
  download: [['path', { d: 'M12 4.5v10M7.5 10.5 12 15l4.5-4.5M5 19.5h14' }]],
  upload: [['path', { d: 'M12 15V4.5M7.5 9 12 4.5 16.5 9M5 19.5h14' }]],
  trash: [
    ['path', { d: 'M5 7h14M10 7V5h4v2' }],
    ['path', { d: 'M7 7l.9 12.1a1 1 0 0 0 1 .9h6.2a1 1 0 0 0 1-.9L17 7' }],
  ],
  file: [
    ['path', { d: 'M7 3.5h7l4.5 4.5v12a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5z' }],
    ['path', { d: 'M14 3.5V8h4.5' }],
  ],
  check: [['path', { d: 'M5 12.5 10 17.5 19 7' }]],
  sun: [
    ['circle', { cx: 12, cy: 12, r: 3.8 }],
    ['path', { d: 'M12 2.8v2M12 19.2v2M2.8 12h2M19.2 12h2M5.5 5.5l1.4 1.4M17.1 17.1l1.4 1.4M5.5 18.5l1.4-1.4M17.1 6.9l1.4-1.4' }],
  ],
  moon: [['path', { d: 'M19.5 14.5A7.8 7.8 0 0 1 9.5 4.5a7.8 7.8 0 1 0 10 10z' }]],
  device: [
    ['rect', { x: 3.5, y: 4.5, width: 17, height: 11.5, rx: 1.5 }],
    ['path', { d: 'M9 20h6M12 16v4' }],
  ],
  summary: [['path', { d: 'M5 6h14M5 10h14M5 14h9M5 18h6' }]],
  paperclip: [['path', { d: 'M20 11.5l-7.8 7.8a5 5 0 0 1-7.1-7.1l8.5-8.5a3.3 3.3 0 0 1 4.7 4.7l-8.5 8.5a1.7 1.7 0 0 1-2.4-2.4l7.8-7.8' }]],
  image: [
    ['rect', { x: 3.5, y: 4.5, width: 17, height: 15, rx: 2 }],
    ['circle', { cx: 9, cy: 9.5, r: 1.6 }],
    ['path', { d: 'M4 17l5-4.5 3.5 3 3-2.5 4.5 4' }],
  ],
  flask: [
    ['path', { d: 'M9.5 3.5h5M10.5 3.5v5.2L5.4 17.6A2 2 0 0 0 7.1 20.5h9.8a2 2 0 0 0 1.7-2.9l-5.1-8.9V3.5' }],
    ['path', { d: 'M7.6 14h8.8' }],
  ],
  search: [
    ['circle', { cx: 10.5, cy: 10.5, r: 6 }],
    ['path', { d: 'M15 15l5 5' }],
  ],
  bulb: [
    ['path', { d: 'M9.5 17.5h5M10.5 20.5h3' }],
    ['path', { d: 'M12 3.5a5.5 5.5 0 0 0-3.2 10c.6.5.9 1.1.9 1.8v.2h4.6v-.2c0-.7.3-1.3.9-1.8A5.5 5.5 0 0 0 12 3.5z' }],
  ],
  megaphone: [
    ['path', { d: 'M4 10v4l10 4.5v-13z' }],
    ['path', { d: 'M14 8.5h2.5a3.5 3.5 0 0 1 0 7H14' }],
    ['path', { d: 'M6.5 15l1.3 4.5h2.8l-1-3.6' }],
  ],
  share: [
    ['circle', { cx: 17.5, cy: 5.5, r: 2.3 }],
    ['circle', { cx: 6.5, cy: 12, r: 2.3 }],
    ['circle', { cx: 17.5, cy: 18.5, r: 2.3 }],
    ['path', { d: 'M8.5 10.8l7-4.1M8.5 13.2l7 4.1' }],
  ],
  gift: [
    ['rect', { x: 4, y: 9, width: 16, height: 11, rx: 1.5 }],
    ['path', { d: 'M3.5 9h17M12 9v11M12 9c-1.5-3.5-5.5-4-5.5-1.5S10 9 12 9zM12 9c1.5-3.5 5.5-4 5.5-1.5S14 9 12 9z' }],
  ],
  intro: [
    ['circle', { cx: 6.5, cy: 15.5, r: 2.5 }],
    ['circle', { cx: 17.5, cy: 15.5, r: 2.5 }],
    ['path', { d: 'M9 15.5c1-3.5 5-3.5 6 0' }],
    ['circle', { cx: 12, cy: 7, r: 1.8 }],
  ],
  done: [
    ['circle', { cx: 12, cy: 12, r: 8 }],
    ['path', { d: 'M8.3 12.3l2.5 2.5 5-5.2' }],
  ],
  outline: [['path', { d: 'M4.5 6h1M8.5 6h11M7.5 10.5h1M11.5 10.5h8M7.5 15h1M11.5 15h8M4.5 19.5h1M8.5 19.5h11' }]],
  faq: [
    ['path', { d: 'M5.5 5h13a1.5 1.5 0 0 1 1.5 1.5v8.5a1.5 1.5 0 0 1-1.5 1.5H11l-4.5 3.5v-3.5h-1A1.5 1.5 0 0 1 4 15V6.5A1.5 1.5 0 0 1 5.5 5z' }],
    ['path', { d: 'M10 9.2a2 2 0 1 1 2.7 1.9c-.5.2-.7.6-.7 1.1v.3M12 14.6v.1' }],
  ],
  timeline: [
    ['rect', { x: 4, y: 5.5, width: 16, height: 14, rx: 1.5 }],
    ['path', { d: 'M4 10h16M8.5 3.5v3.5M15.5 3.5v3.5M8 13.5h2M12 13.5h2M8 16.5h2' }],
  ],
  warning: [
    ['path', { d: 'M12 4.5 20.5 19H3.5z' }],
    ['path', { d: 'M12 10v4M12 16.8v.1' }],
  ],
  mindmap: [
    ['circle', { cx: 7, cy: 12, r: 2.5 }],
    ['circle', { cx: 18, cy: 6, r: 2 }],
    ['circle', { cx: 18, cy: 12, r: 2 }],
    ['circle', { cx: 18, cy: 18, r: 2 }],
    ['path', { d: 'M9.3 11c2.5-1 3.7-5 6.7-5M9.5 12H16M9.3 13c2.5 1 3.7 5 6.7 5' }],
  ],
  podcast: [
    ['path', { d: 'M4.5 15.5v-3a7.5 7.5 0 0 1 15 0v3' }],
    ['rect', { x: 3.5, y: 14, width: 4, height: 6, rx: 1.5 }],
    ['rect', { x: 16.5, y: 14, width: 4, height: 6, rx: 1.5 }],
  ],
  signout: [
    ['path', { d: 'M10 4.5H6.5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2H10' }],
    ['path', { d: 'M15 8l4 4-4 4M19 12H9.5' }],
  ],
};

export const ICON_NAMES = Object.keys(I);

export default function Icon({ name, size = 20, className = '', title }) {
  const parts = I[name];
  if (!parts) return null;
  return (
    <svg
      className={`bn-icon ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : 'true'}
      role={title ? 'img' : undefined}
    >
      {title && <title>{title}</title>}
      {parts.map(([Tag, attrs], i) => <Tag key={i} {...attrs} />)}
    </svg>
  );
}

/* A button that is only an icon. Its label is the accessible name and the
   tooltip, so an icon never has to be guessed at.

   variant: quiet (default) | primary | danger     size: sm | md */
export function IconButton({
  icon, label, onClick, variant = 'quiet', size = 'md', pressed, disabled, type = 'button', className = '',
}) {
  return (
    <button
      type={type}
      className={`ibtn ibtn-${variant} ibtn-${size} ${className}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      aria-pressed={pressed === undefined ? undefined : pressed}
      data-tip={label}
    >
      <Icon name={icon} size={size === 'sm' ? 18 : 20} />
    </button>
  );
}
